/* This file is autogenerated, see readme.md for instructions */
import BurySvgIcon from '@bloomreach/banana-theme/icons/bury.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BuryIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BurySvgIcon />
    </Icon>
  );
});

BuryIcon.displayName = 'BuryIcon';

export default BuryIcon;
